<template lang="pug">
v-flex(xs12 :class="{ 'pr-3': $vuetify.breakpoint.lgAndUp }")
  div.expande-horizontal.centraliza.wrap
    v-flex(xs12).mb-4
      v-card(flat class="checkout-block pa-4")
        div.expande-horizontal.align-center.mb-3
          v-avatar(size="36" color="#ebf1ff").mr-3
            v-icon(color="#3158d3") mdi-account-circle-outline
          div
            div.checkout-title Dados da conta
            div.checkout-subtitle Preencha seus dados para seguir ao pagamento

        v-form(ref="form_checkout")
          div.expande-horizontal.wrap
            v-flex(xs12).mb-2
              v-text-field(
                outlined
                dense
                class="field-modern"
                label="Nome completo"
                :rules="[v => !!v || 'Preencha este campo']"
                placeholder="Ex: Maria das Gracas"
                v-model="get_checkout.payer.name"
                prepend-inner-icon="mdi-account-outline"
              )
            v-flex(xs12).mb-2
              v-text-field(
                outlined
                dense
                class="field-modern"
                label="E-mail"
                placeholder="Ex: maria@gmail.com"
                :rules="[v => !!v || 'Preencha este campo']"
                v-model="get_checkout.payer.email"
                prepend-inner-icon="mdi-email-outline"
              )
            v-flex(xs12 md6 :class="{ 'pr-3': $vuetify.breakpoint.lgAndUp }").mb-2
              v-text-field(
                outlined
                dense
                class="field-modern"
                label="CPF ou CNPJ"
                placeholder="Insira seu documento"
                :rules="[v => (!!v && (validarCPF() || validarCNPJ())) || 'Documento invalido']"
                v-mask=['###.###.###-##']
                v-model="get_checkout.payer.cpf_cnpj"
                prepend-inner-icon="mdi-card-account-details-outline"
              )
            v-flex(xs12 md2 :class="{ 'pr-3': $vuetify.breakpoint.lgAndUp }").mb-2
              v-text-field(
                outlined
                dense
                class="field-modern"
                label="DDD"
                placeholder="96"
                v-model="get_checkout.payer.phone_prefix"
                :rules="[v => !!v || 'Obrigatorio']"
              )
            v-flex(xs12 md4).mb-2
              v-text-field(
                outlined
                dense
                class="field-modern"
                label="Celular"
                placeholder="9 8419 6827"
                v-model="get_checkout.payer.phone"
                :rules="[v => !!v || 'Obrigatorio']"
                v-mask="['# #### ####']"
                prepend-inner-icon="mdi-cellphone"
              )
            v-flex(xs12).pt-2
              v-btn.checkout-next-btn.fonte.text-none(block large @click="validateForm" :color="$theme.third" dark)
                | Continuar para pagamento
                v-icon.ml-2(size="18") mdi-arrow-down
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_checkout"])
  },
  methods: {
    validateForm() {
      if (this.$refs.form_checkout.validate()) {
        this.get_checkout.seller = this.$route.query.s_id;
        this.$vuetify.goTo(2000);
        this.$store.dispatch("createGlobalMessage", {
          type: "success",
          message: "Dados validados. Agora escolha a forma de pagamento.",
          timeout: 4000
        });
      }
    },
    validarCPF() {
      let cpf = this.get_checkout.payer.cpf_cnpj;
      cpf = cpf.replace(/[^\d]+/g, "");

      if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
      }

      var soma = 0;
      var resto;

      for (var i = 1; i <= 9; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }

      resto = (soma * 10) % 11;

      if (resto === 10 || resto === 11) {
        resto = 0;
      }

      if (resto !== parseInt(cpf.substring(9, 10))) {
        return false;
      }

      soma = 0;

      for (i = 1; i <= 10; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }

      resto = (soma * 10) % 11;

      if (resto === 10 || resto === 11) {
        resto = 0;
      }

      if (resto !== parseInt(cpf.substring(10, 11))) {
        return false;
      }

      return true;
    },
    validarCNPJ() {
      let cnpj = this.get_checkout.payer.cpf_cnpj;
      cnpj = cnpj.replace(/[^\d]+/g, "");

      if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) {
        return false;
      }

      var tamanho = cnpj.length - 2;
      var numeros = cnpj.substring(0, tamanho);
      var digitos = cnpj.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;

      for (var i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }

      var resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

      if (resultado !== parseInt(digitos.charAt(0))) {
        return false;
      }

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;

      for (i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }

      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

      if (resultado !== parseInt(digitos.charAt(1))) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.checkout-block {
  border: 1px solid #e9ecf5;
  border-radius: 14px;
  background: #fbfcff;
}

.checkout-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.checkout-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.checkout-next-btn {
  border-radius: 12px;
  letter-spacing: 0.2px;
}

.field-modern {
  border-radius: 10px;
}
</style>
